import { ExchangeRecord } from "../reducers/exchange/exchanges";

export const ORDERGROOVE_LEDGER_CURRENCY_PREFIX = "_Ordergroove.";

/**
 * Checks if an exchange record is an Ordergroove reward by looking at its ledger currency.
 */
export const isOrdergrooveReward = (exchange: ExchangeRecord): boolean => {
  return !!(
    (exchange?.reward?.rewardType === "ledger" &&
      exchange?.reward?.ledgerCurrency?.startsWith(
        ORDERGROOVE_LEDGER_CURRENCY_PREFIX
      )) ||
    exchange?.reward?.processor === "ordergroove" ||
    exchange?.ledgerCurrency?.startsWith(ORDERGROOVE_LEDGER_CURRENCY_PREFIX) ||
    exchange?.reward?.ordergrooveRewardConfig
  );
};

/**
 * Logic to determine if an Ordergroove reward should be disabled due to subscription status.
 * Accepts an optional pre-computed isOrdergroove flag to avoid redundant prefix checks.
 */
export const shouldDisableOrdergroove = (
  exchange: ExchangeRecord,
  ordergrooveSubscriptionActive: boolean | undefined,
  isOrdergroove?: boolean
): boolean => {
  const isOG = isOrdergroove ?? isOrdergrooveReward(exchange);
  
  if (!isOG) {
    return false;
  }

  // If subscription status is explicitly false, we disable the reward.
  // If it's undefined (e.g., loading or error), we default to disabled (fail-closed).
  return ordergrooveSubscriptionActive !== true;
};
